
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schools/the-national-college",
      function () {
        return require("private-next-pages/schools/the-national-college/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schools/the-national-college"])
      });
    }
  